import React, { useEffect, useState } from "react";
import { Card, Col, Row, } from "react-bootstrap";
import styles from './style.module.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

function Details({ next }) {

    const [name, setname] = useState()
    const [phone, setPhone] = useState()
    const [postCode, setPostCode] = useState()
    const [selectedSlotDay, setSelectedSlotDay] = useState("")
    const [selectedSlotTime, setSelectedSlotTime] = useState("")
    const [selectedDate, setSelectedDate] = useState();
    const [startDate, setStartDate] = useState(new Date().setDate(new Date().getDate() + 2));
    const options = [
        {
            label: "Mumbai",
            value: "Mumbai",
        },
        {
            label: "Delhi-NCR",
            value: "Delhi-NCR",
        }
    ];
    const [selectedCity, setSelectedCity] = useState("");

    useEffect(() => {
    })

    const validateForm = (element) => {
        let name = document.getElementById("name");
        let nameError = document.getElementById("nameError");
        let phone = document.getElementById("phone");
        let phoneError = document.getElementById("phoneError");
        let postCode = document.getElementById("postCode");
        let postCodeError = document.getElementById("postCodeError");
        let slotError = document.getElementById("slotError");

        if (element === "name" || element === "submit") {
            if (name.value === "") {
                name.style.border = "1px solid red";
                nameError.innerHTML = "Name is required";
            } else {

                nameError.innerHTML = "";
                name.style.border = "1px solid black";

            }
        }
        if (element === "phone" || element === "submit") {
            if (phone.value === "") {
                phone.style.border = "1px solid red";
                phoneError.innerHTML = "phone is required";
            } else {
                if (!phone.value.match(/^\d{10}$/)) {
                    phoneError.innerHTML = "Please enter valid phone number";
                    phone.style.border = "1px solid red";
                } else {
                    phoneError.innerHTML = "";
                    phone.style.border = "1px solid black";
                }
            }
        }
        if (element === "postCode" || element === "submit") {
            if (postCode.value === "") {
                postCode.style.border = "1px solid red";
                postCodeError.innerHTML = "PostCode / ZIP is required";
            } else {
                if (!postCode.value.match(/^\d{6}$/)) {
                    postCodeError.innerHTML = "Please enter valid postcode / ZIP";
                    postCode.style.border = "1px solid red";
                } else {
                    postCodeError.innerHTML = "";
                    postCode.style.border = "1px solid black";
                }
            }
        }

        if (element === "submit" && nameError.innerHTML === "" && phoneError.innerHTML === "" && postCodeError.innerHTML === "") {
            let city = document.getElementById("city");
            let cityError = document.getElementById("cityError");
            if (selectedCity === "") {
                cityError.innerHTML = "City is required";
                city.style.border = "1px solid red";
            } else {
                cityError.innerHTML = "";
                city.style.border = "1px solid black";

                if (selectedSlotTime === "") {
                    slotError.innerHTML = "Please select slot";
                } else {
                    submit();
                }
            }
        }
    }

    const submit = () => {
        var data = {
            "lead_info": {
                "name": name,
                "phnum": phone,
                "cgid": "",
                "service": "Attendant",
                "pkg_type": "trial",
                "cx_pincode": postCode,
                "starttype": "immediate",
                "slot": selectedSlotDay + ": " + selectedSlotTime,
                "city": selectedCity,
                "slot_date": selectedSlotDay === "Today" ? moment().format("DD-MM-yyyy") : selectedSlotDay === "Tomorrow" ? moment().add(1, "day").format("DD-MM-yyyy") : moment(selectedDate).format("DD-MM-yyyy")
            }
        };
        next(data);
    }

    return (
        <>

            <div className="mt-3">
                <div className="pt-1">
                    <div className="text-center" style={{ color: '#58d9cf', fontWeight: 'bold' }}>Step 1</div>
                    <div style={{ fontWeight: "bold", fontSize: "22px" }} className="mb-4 text-center">Billing Details</div>
                </div>
                <form className="form-group p-1">
                    <label className="form-label"><span>Name</span><span style={{ color: "red" }}>*</span></label>
                    <input type={"text"} id="name" className="form-control" placeholder="Enter your name" defaultValue={name} onBlur={() => {
                        validateForm("name")
                    }}
                        onChange={(e) => setname(e.target.value)}></input>
                    <p id="nameError" style={{ color: "red" }}></p>
                    <label className="form-label"><span>Phone</span><span style={{ color: "red" }}>*</span></label>
                    <input type={"text"} id="phone" className="form-control" placeholder="Enter phone number" defaultValue={phone} onBlur={() => {
                        validateForm("phone")
                    }}
                        onChange={(e) => setPhone(e.target.value)}></input>
                    <p id="phoneError" style={{ color: "red" }}></p>
                    <label className="form-label" ><span>PostCode / ZIP</span><span style={{ color: "red" }}>*</span></label>
                    <input type={"text"} id="postCode" className="form-control" placeholder="Enter postcode" defaultValue={postCode} onBlur={() => {
                        validateForm("postCode")
                    }}
                        onChange={(e) => setPostCode(e.target.value)}></input>
                    <p id="postCodeError" style={{ color: "red" }}></p>
                    <label className="form-label" ><span>City</span><span style={{ color: "red" }}>*</span></label>
                    <select className="form-control" id="city" placeholder="Select city" onChange={(value) => {
                        setSelectedCity(value.target.value);
                    }}>
                        <option defaultValue="" hidden>Please Choose...</option>
                        {options.map((option) => (
                            <option defaultValue={option.value}>{option.label}</option>
                        ))}
                    </select>
                    <p id="cityError" style={{ color: "red" }}></p>
                    <label className="form-label" ><span>Select Slot</span><span style={{ color: "red" }}>*</span></label>
                    <Row>
                        {new Date().getHours() < 12 && <div style={{ width: "100px" }} >
                            <Card style={{ backgroundColor: selectedSlotDay === "Today" ? "#d9edf7" : "white", }} onClick={() => {
                                setSelectedSlotDay("Today");
                            }}>
                                <div className="p-2 text-center">Today</div>
                            </Card>
                        </div>}
                        <div style={{ width: "130px" }}>
                            <Card style={{ backgroundColor: selectedSlotDay === "Tomorrow" ? "#d9edf7" : "white", }} onClick={() => {
                                setSelectedSlotDay("Tomorrow");
                            }}>
                                <div className="p-2 text-center">Tomorrow </div>
                            </Card>
                        </div>
                        <div style={{ width: "130px" }}>
                            <Card style={{ backgroundColor: selectedSlotDay === "Others" ? "#d9edf7" : "white", }} onClick={() => {
                                setSelectedSlotDay("Others");
                            }}>
                                <div className="p-2 text-center">Other </div>
                            </Card>
                        </div>
                    </Row>
                    {selectedSlotDay === "Today" && <Row className="mt-2">
                        <div style={{ width: "90px" }} >
                            <Card style={{ backgroundColor: selectedSlotTime === "4 PM" ? "#d9edf7" : "white", }} onClick={() => {
                                setSelectedSlotTime("4 PM");
                            }}>
                                <div className="p-2 text-center">4 PM</div>
                            </Card>
                        </div>
                        <div style={{ width: "90px" }} >
                            <Card style={{ backgroundColor: selectedSlotTime === "6 PM" ? "#d9edf7" : "white", }} onClick={() => {
                                setSelectedSlotTime("6 PM");
                            }}>
                                <div className="p-2 text-center">6 PM</div>
                            </Card>
                        </div>
                    </Row>}
                    {selectedSlotDay === "Tomorrow" && <Row className="mt-2">
                        {new Date().getHours() < 20 &&
                            <>
                                <div style={{ width: "90px" }} >
                                    <Card style={{ backgroundColor: selectedSlotTime === "10 AM" ? "#d9edf7" : "white", }} onClick={() => {
                                        setSelectedSlotTime("10 AM");
                                    }}>
                                        <div className="p-2 text-center">10 AM</div>
                                    </Card>
                                </div>
                                <div style={{ width: "90px" }} >
                                    <Card style={{ backgroundColor: selectedSlotTime === "4 PM" ? "#d9edf7" : "white", }} onClick={() => {
                                        setSelectedSlotTime("4 PM");
                                    }}>
                                        <div className="p-2 text-center">4 PM</div>
                                    </Card>
                                </div>
                            </>}
                        <div style={{ width: "90px" }} >
                            <Card style={{ backgroundColor: selectedSlotTime === "6 PM" ? "#d9edf7" : "white", }} onClick={() => {
                                setSelectedSlotTime("6 PM");
                            }}>
                                <div className="p-2 text-center">6 PM</div>
                            </Card>
                        </div>
                    </Row>}
                    {selectedSlotDay === "Others" &&
                        <div>
                            <div className="mt-2" style={{ width: 200 }}>
                                <DatePicker   dateFormat="dd/MM/yyyy" dat className="form-control mt-2" placeholderText="Please Select Date" style={{ width: 200 }} selected={selectedDate} onChange={(date) => setSelectedDate(date)} minDate={startDate} />
                            </div>
                            <Row className="mt-2">
                                {selectedDate && selectedDate !== "" &&
                                    <>
                                        <div style={{ width: "90px" }} >
                                            <Card style={{ backgroundColor: selectedSlotTime === "10 AM" ? "#d9edf7" : "white", }} onClick={() => {
                                                setSelectedSlotTime("10 AM");
                                            }}>
                                                <div className="p-2 text-center">10 AM</div>
                                            </Card>
                                        </div>
                                        <div style={{ width: "90px" }} >
                                            <Card style={{ backgroundColor: selectedSlotTime === "4 PM" ? "#d9edf7" : "white", }} onClick={() => {
                                                setSelectedSlotTime("4 PM");
                                            }}>
                                                <div className="p-2 text-center">4 PM</div>
                                            </Card>
                                        </div>
                                        <div style={{ width: "90px" }} >
                                            <Card style={{ backgroundColor: selectedSlotTime === "6 PM" ? "#d9edf7" : "white", }} onClick={() => {
                                                setSelectedSlotTime("6 PM");
                                            }}>
                                                <div className="p-2 text-center">6 PM</div>
                                            </Card>
                                        </div>
                                    </>}
                            </Row>
                        </div>}
                    <p id="slotError" style={{ color: "red" }}></p>
                    <Row className="mt-3">
                        <Col className="col-12  text-end">
                            <button type="button" className="btn" style={{ backgroundColor: "#2b7dbd", color: "white" }} onClick={() => {
                                validateForm("submit");
                            }}>Next</button>
                        </Col>
                    </Row>
                </form>
            </div >
        </>
    );
}

export default Details